import { merchantActionTypes } from '../action-types';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import toastMessage, { errorAlert } from '../../../components/ToastMessage';
import { toaster } from 'rsuite';
import * as React from 'react';
import { IAction, IEventType } from '../merchant-interfaces';
import { IWebhookData } from '../../../components/developers/webhooks_page/WebhookCreateComponent';
import { IWebhookLogParams } from '../../../views/developers/Logs';
import { MRT_PaginationState } from 'material-react-table';
import { GET } from '../../store-helper';

export const fetchWebhookEventType = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_WEBHOOK_EVENT_TYPES_LOADING });

		const data = await GET({ pathname: `${BASE_URL.WEBHOOKS}/webhooks/EventTypes` });

		dispatch({ type: merchantActionTypes.FETCH_WEBHOOK_EVENT_TYPES, payload: data ?? [] });
	} catch (e) {
		sendSentryMessage({ name: `GET Fetch webhooks error`, context: e });
		console.log(e);
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const fetchWebhookData = async (
	webhookId: string,
	setInitialValues: (data: IWebhookData) => void
): Promise<void> => {
	try {
		const res = await axios.get(`${BASE_URL.WEBHOOKS}/Webhooks/${webhookId}`);
		if (res?.data) {
			setInitialValues(res.data);
		}
	} catch (e) {
		Sentry.setTag('fetch-webhook-data-id', webhookId);
		sendSentryMessage({ name: `GET Fetch webhook data error`, context: e });
		console.log(e);
	}
};

export const setWebhook = async (body: IEventType): Promise<void> => {
	await axios.post(`${BASE_URL.WEBHOOKS}/webhooks`, body);
};

export const updateWebhook = async (body: IEventType): Promise<void> => {
	await axios.put(`${BASE_URL.WEBHOOKS}/webhooks`, body);
};


export const deleteWebhook = async (webhookId: string, mid?: string, pid?: string): Promise<void> => {
	let url = `${BASE_URL.WEBHOOKS}/Webhooks/${webhookId}`;
	if (mid) {
		url += `?mid=${mid}`;
	} else if (pid) {
		url += `?pid=${pid}`;
	}
	await axios.delete(url);
};

export const fetchWebhookLogs = async (dispatch: React.Dispatch<IAction>, params: IWebhookLogParams): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_WEBHOOK_LOGS_LOADING });
		const res = await axios.get(`${BASE_URL.WEBHOOKS}/webhooks/log`, { params });
		dispatch({ type: merchantActionTypes.FETCH_WEBHOOK_LOGS_DATA, payload: res?.data?.rows ?? [], totalItemCount: res?.data?.totalItemCount });
	} catch (e) {
		sendSentryMessage({ name: `GET Fetch webhook logs error`, context: e });
		console.log(e);
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const setWebhookLogsPagination = (dispatch: React.Dispatch<IAction>, value: MRT_PaginationState): void => {
	dispatch({
		type: merchantActionTypes.SET_WEBHOOK_LOGS_TABLE_PAGINATION,
		payload: {
			pageNumber: value.pageIndex,
			pageSize: value.pageSize
		}
	});
};

export const resendWebhook = async (id: string): Promise<void> => {
	try {
		await axios.post(`${BASE_URL.WEBHOOKS}/webhooks/re-send?eventInvocationId=${id}`);
		toaster.push(toastMessage({
			text: 'Webhook resend',
			type: 'success'
		}), { placement: 'topEnd' });
	} catch (e) {
		sendSentryMessage({ name: `POST resend webhook error`, context: e });
		console.log(e.response);
		errorAlert({
			title: 'Error',
			duration: 0,
			closable: true
		});
	}
};
